import { render } from "./CardEstatistica.vue?vue&type=template&id=03c51fd0"
import script from "./CardEstatistica.vue?vue&type=script&lang=js"
export * from "./CardEstatistica.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__